export default __webpack_public_path__ + "static/media/gang-rueef-de-bruune.924202f7.png";